import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  PortfolioAnalysisUploadedFileInfo as PortfolioAnalysisData,
  PortfolioAnalysisPageFilter,
  TimeRange,
} from "@/types";
import { IndexType } from "@/types/IndexType";

export const enabledPortfolioAnalysisIndexes: IndexType[] = [IndexType.SIM, IndexType.SIPI];

const defaultFilter: PortfolioAnalysisPageFilter = {
  selectedIndexes: enabledPortfolioAnalysisIndexes,
  selectedTimeRanges: [TimeRange.OneYear, TimeRange.ThreeYears],
};

export interface PortfolioAnalysisPageSliceState {
  filter: PortfolioAnalysisPageFilter;
  analysisData?: PortfolioAnalysisData;
}

const initialState: PortfolioAnalysisPageSliceState = {
  filter: defaultFilter,
  analysisData: undefined,
};

export const portfolioAnalysisPageSlice = createSlice({
  name: "portfolioAnalysisPage",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<PortfolioAnalysisPageFilter>) => {
      state.filter = action.payload;
    },
    setAnalysisData: (state, action: PayloadAction<PortfolioAnalysisData | undefined>) => {
      state.analysisData = action.payload;
    },
  },
});

export const { setFilter, setAnalysisData } = portfolioAnalysisPageSlice.actions;

export const PortfolioAnalysisPageReducer = portfolioAnalysisPageSlice.reducer;
